// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-footer[data-v-40ab164b] {\n  flex: 0;\n  padding: 10px 14px;\n}\n.v-footer .text-caption[data-v-40ab164b] {\n  margin-top: 10px;\n  font-size: 0.65rem !important;\n  line-height: 0.65rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
